import {Component, forwardRef} from '@angular/core';
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {IIdDescription} from "../../../models";
import {DictionariesService} from "../../../service";
import {ViewDictionaryBase} from "../view-dictionary-base";

@Component({
  selector: 'app-dict-qref-vidInfo-op',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => QrefVidInfoOpViewComponent),
    multi: true
  }],
  template: `

      <label class="form-label">{{title}}
        <app-rq *ngIf="isFieldReq(formControl)" [isReadOnly]="isDisabled"></app-rq>
      </label>
      <app-custom-select *ngIf="dictionary | async as dict; else loading"
                         code="id"
                         name="description"
                         [items]="dict"
                         [returnOnlyId]="true"
                         [formControl]="formControl"
                         [fieldsFromSearch]="'description'"
                         [isInvalid]="submitted && formControl.errors">
        <ng-template let-item #labelTemplate>
          {{ item.description }}
        </ng-template>
        <ng-template let-item let-search="search" #optionTemplate>
          {{ item.description }}
        </ng-template>
      </app-custom-select>
      <ng-template #loading>
        ...загрузка
      </ng-template>
      <app-valid [logic]="formControl" [submitted]="submitted"></app-valid>

  `
})
export class QrefVidInfoOpViewComponent extends ViewDictionaryBase<IIdDescription> {
  getDictionary = this.dictSrv.getVidInfoOpList();
  constructor(private dictSrv: DictionariesService) {
    super();
  }
}
